<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      justify-center
      align-center
    >
      <v-flex
        xs12
        sm8
      >
        <v-card>
          <v-toolbar
            dark
            flat
            class="red darken-1"
          >
            <v-icon x-large>error_outline</v-icon>
            <v-toolbar-title class="headline">Error</v-toolbar-title>
          </v-toolbar>

          <v-card-text primary-title>
            <div class="body-2 text-xs-center mb-1">Details for developers:</div>

            <code class="error__code">
              <div v-if="isTypeError">{{ error.stack }}</div>
              <div v-if="isAxiosError">{{ pick(error, ['message', 'statusCode', 'config.url', 'config.method', 'response.data']) }}</div>
              <div v-else>{{ { fullPath: $route.fullPath, ...pick(error, ['message', 'statusCode']) } }}</div>
              <div>{{ new Date().toString() }}</div>
            </code>
          </v-card-text>

          <v-card-actions class="pt-3 pb-3">
            <v-layout
              row
              justify-center
            >
              <v-btn
                v-if="isServerError"
                @click="$router.go()"
              >
                <v-icon>loop</v-icon>reconnect
              </v-btn>

              <v-btn
                v-else
                @click="$router.push('/dashboard')"
              >go to dashboard</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { pick } from 'lodash'

  export default {
    props: {
      error: {
        required: true,
        type: [Error, Object]
      }
    },
    computed: {
      isTypeError () {
        return this.error.statusCode === 'TypeError'
      },
      isAxiosError () {
        return this.error.isAxiosError != null && this.error.isAxiosError === true
      },
      isServerError () {
        return this.isAxiosError && this.error.statusCode >= 500
      }
    },
    methods: {
      pick
    }
  }
</script>

<style lang="scss">
  .error {
    &__code {
      display: block;
      overflow-x: auto;
      padding: 7px;

      &:before, &:after {
        content: none;
      }

      > div:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
</style>
